export const translations = {
  tr: {
    nav: { about: "Hakkımızda", services: "Hizmetlerimiz", contact: "İletişim", cta: "Yük Ver" },
    home: {
      eyebrow: "TÜRKİYE'NİN DİJİTAL YÜK & NAKLİYE PLATFORMU",
      h1_line1: "Yükünü ver,",
      h1_line2: "şoförünü bul.",
      sub: "Müşteri, şoför ve yönetim tek panelde. Saniyeler içinde eşleş, canlı takip et, güvenle ödemeni yap.",
      cta: "Yük Ver",
      cta_secondary: "Nasıl çalışır?",
      scroll: "Kaydır",
      journey: [
        { no: "01", title: "Yükleme Alanı", desc: "Yukarıdan bak: paletler istiflenir, yükün araca dijital olarak hazırlanır." },
        { no: "02", title: "Depo", desc: "Yükün depoya taşınır, sisteme işlenir ve en hızlı rotayla sevkiyata çıkar." },
        { no: "03", title: "Teslimat", desc: "Yük, dijital rota üzerinden dükkanın kapısına, tam zamanında ulaşır." },
      ],
      intro_title_1: "Yükü biz taşırız.",
      intro_title_2: "Sonucun sahibi biziz.",
      intro_body: "Her hizmet tek çatı altında ve tek sorumlu ekiple; tedarik zincirin işinin gerektirdiği gibi hareket eder: öngörülebilir, şeffaf ve bahanesiz. Tedarikçiler arası suçlama yok, aktarımlarda kaybolan gecikme yok — çıkıştan varışa tek ekip.",
      intro_link: "Hakkımızda",
      stats_kicker: "Sayısız yolculuktan netlik doğar",
      speed_label: "ortalama teslim performansı",
      services_title_1: "Yükün için gereken her şey.",
      services_title_2: "Tek platformda.",
      services_sub: "Yük eşleştirmeden canlı takibe, güvenli ödemeden geniş şoför ağına — tüm süreç uçtan uca tek yerde.",
      why_kicker: "Neden biz",
      why_title: "Senin kadar çok çalışan bir lojistik.",
      why: [
        { t: "Tek İletişim Noktası", d: "Birden fazla tedarikçiyi kovalamak yok. Tek ekip, yükünü çıkıştan varışa yönetir." },
        { t: "Uçtan Uca Görünürlük", d: "Yükünü gerçek zamanlı izle; sorunlar gecikmeye dönüşmeden proaktif bilgi al." },
        { t: "Güvenilir Uyumluluk", d: "Doğrulanmış şoförler ve sigortalı taşımalarla her işlem güvence altında." },
        { t: "Şeffaf Fiyatlandırma", d: "Gizli ücret yok. Net, rekabetçi fiyat ve her adımda hızlı destek." },
        { t: "Hızlı Çözüm", d: "Beklenmedik bir durumda parmakla göstermeyiz — anında çözeriz." },
      ],
      reliability_title_1: "Her aşamada",
      reliability_title_2: "güven.",
      features: [
        { t: "Gerçek Zamanlı Takip", d: "Yükünün nerede olduğunu her aşamada tam olarak bil. Canlı görünürlük, sıfır tahmin." },
        { t: "Geniş Şoför Ağı", d: "81 ilde on binlerce doğrulanmış şoför; işinin ihtiyaç duyduğu her rotada." },
        { t: "7/24 Destek", d: "Gerçek insanlar, her an ulaşılabilir. Rutin ya da acil — telefonu açar, sonucu sahipleniriz." },
      ],
      testimonials_kicker: "Referanslar",
      testimonials_title: "Türkiye genelinde işletmelerin güveni",
      testimonials: [
        { q: "Aportta olmadan operasyonumuz yürümezdi. Yüklerimizi kendi yüküymüş gibi sahipleniyorlar; hızlı ve şeffaflar.", n: "Mehmet Yıldız", r: "Operasyon Direktörü, Anadolu Tekstil" },
        { q: "Büyük firmalarda bulamadığımız kişisel hizmeti burada bulduk. Bize özel hesap yöneticisi işimizi biliyor.", n: "Ayşe Demir", r: "Tedarik Zinciri Müdürü, Ege Gıda" },
        { q: "Fiyatlar net, takip canlı, destek her an açık. En hızlı rotayı her seferinde buluyorlar.", n: "Can Kaya", r: "Genel Müdür, Marmara Lojistik" },
      ],
      partners_kicker: "İş ortaklarımız",
      partners: ["ANADOLU NAKLİYAT", "EGE LOJİSTİK", "MARMARA KARGO", "TOROS TAŞIMA", "KARADENİZ FİLO", "AKDENİZ EXPRESS", "İÇ ANADOLU YÜK", "TRAKYA TRANS"],
      faq_title: "S.S.S",
      faq_sub: "Net cevaplar, güvenle ilerle.",
      faqs: [
        { q: "Aportta ne yapar?", a: "Aportta, yük verenle şoförü saniyeler içinde eşleştiren; canlı takip ve güvenli ödeme sunan dijital yük & nakliye platformudur." },
        { q: "Yükümü nasıl veririm?", a: "app.aportta.com üzerinden ilanını oluşturur, güzergâh ve yük bilgisini girer, fiyatını belirlersin. Algoritma en uygun şoförle eşleştirir." },
        { q: "Ödeme nasıl çalışır?", a: "Ödemen teslimat onaylanana kadar güvence altında tutulur; onaydan sonra şoföre aktarılır." },
        { q: "Hangi illerde hizmet var?", a: "81 ilde on binlerce aktif şoförle şehir içi ve şehirlerarası taşımalarda hizmet veriyoruz." },
        { q: "Yükümü nasıl takip ederim?", a: "Yük yola çıktığı andan teslimata kadar konumu harita üzerinden 7/24 canlı izlersin." },
        { q: "Destek nasıl alırım?", a: "7/24 destek ekibimize telefon veya e-posta ile ulaşabilirsin." },
      ],
      final_title: "Daha akıllı taşımaya hazır mısın?",
      final_sub: "Çağrı merkezi yok, koşuşturma yok. Sadece işini büyütmene yardım eden deneyimli insanlar ve saniyeler içinde eşleşen bir platform.",
      stats: [
        { value: "50K+", label: "Aktif Şoför" },
        { value: "%99", label: "Güvenli Teslimat" },
        { value: "81", label: "İl Kapsama" },
        { value: "7/24", label: "Canlı Destek" },
      ],
      marquee: "GÜVENLİ · HIZLI EŞLEŞME · CANLI TAKİP · GÜVENLİ ÖDEME · 81 İLDE",
      how_title: "Üç adımda yükün yolda",
      how_sub: "Karmaşık aramalar, telefon trafiği ve belirsizlik yok. Sadece net, hızlı ve güvenli bir akış.",
      steps: [
        { no: "01", title: "Yükünü tanımla", desc: "Nereden nereye, ne zaman ve ne taşıyacağını gir. Fiyatını sen belirle." },
        { no: "02", title: "Şoförünle eşleş", desc: "Algoritmamız en uygun, puanı yüksek şoförleri saniyeler içinde eşleştirir." },
        { no: "03", title: "Canlı takip et", desc: "Yükün yola çıktığı andan teslimata kadar her adımı harita üzerinde izle." },
      ],
      cta_band_title: "Yükün bugün yola çıksın.",
      cta_band_sub: "Aportta panelinde saniyeler içinde ilanını oluştur.",
    },
    about: {
      eyebrow: "HAKKIMIZDA",
      title: "Lojistiği yeniden yazıyoruz.",
      intro: "Aportta, Türkiye'nin yük ve nakliye sektörünü şeffaf, hızlı ve güvenilir bir dijital deneyime dönüştürmek için kuruldu.",
      chapters: [
        { no: "01", title: "Vizyonumuz", text: "Her yükün, doğru şoförle en kısa sürede buluştuğu; hiçbir tırın boş dönmediği bir Türkiye hayal ediyoruz. Verimlilik hem çevre hem ekonomi için kazanç." },
        { no: "02", title: "Teknolojimiz", text: "Gerçek zamanlı eşleştirme algoritması, canlı GPS takibi ve güvenli ödeme altyapısı ile tüm süreci tek bir panelde topluyoruz." },
        { no: "03", title: "Güvenimiz", text: "Doğrulanmış şoförler, sigortalı taşımalar ve puan sistemi ile her işlemde güven esas. Paranız teslimat onayına kadar güvende." },
        { no: "04", title: "Ağımız", text: "81 ilde on binlerce aktif şoför ve binlerce işletme. Büyüdükçe herkes için daha hızlı, daha uygun ve daha güvenilir." },
      ],
    },
    services: {
      eyebrow: "HİZMETLERİMİZ",
      title: "Uçtan uca dijital lojistik.",
      intro: "Yük vermekten teslimata kadar ihtiyacın olan her şey tek platformda.",
      items: [
        { title: "Yük Eşleştirme", desc: "Akıllı algoritma yükünü en uygun şoförle saniyeler içinde eşleştirir." },
        { title: "Canlı Takip", desc: "Yükünün konumunu gerçek zamanlı harita üzerinden 7/24 izle." },
        { title: "Güvenli Ödeme", desc: "Ödemen teslimat onaylanana kadar güvence altında tutulur." },
        { title: "Şoför Ağı", desc: "Doğrulanmış, puanlı ve sigortalı geniş şoför ağına anında eriş." },
        { title: "Kurumsal Çözümler", desc: "İşletmeler için toplu yük yönetimi, faturalandırma ve raporlama." },
        { title: "7/24 Destek", desc: "Uzman destek ekibimiz her an yanında, sorunun anında çözülsün." },
      ],
    },
    contact: {
      eyebrow: "İLETİŞİM",
      title: "Konuşalım.",
      intro: "Sorularınız, iş birlikleri ve destek için bize ulaşın.",
      email_label: "E-posta",
      phone_label: "Telefon",
      address_label: "Adres",
      address: "Maslak, Sarıyer, İstanbul, Türkiye",
      hours_label: "Çalışma Saatleri",
      hours: "Hafta içi 09:00 – 18:00 · Destek 7/24",
    },
    footer: {
      tagline: "Türkiye'nin dijital yük & nakliye platformu.",
      rights: "Tüm hakları saklıdır.",
      product: "Ürün",
      company: "Şirket",
    },
  },
  en: {
    nav: { about: "About", services: "Services", contact: "Contact", cta: "Post a Load" },
    home: {
      eyebrow: "TURKEY'S DIGITAL FREIGHT & TRANSPORT PLATFORM",
      h1_line1: "Post your load,",
      h1_line2: "find your driver.",
      sub: "Customers, drivers and operations in one panel. Match in seconds, track live, pay securely.",
      cta: "Post a Load",
      cta_secondary: "How it works",
      scroll: "Scroll",
      journey: [
        { no: "01", title: "Loading Area", desc: "Look from above: pallets are stacked, your load is digitally prepared for the truck." },
        { no: "02", title: "Warehouse", desc: "Your load moves to the warehouse, gets logged and dispatched on the fastest route." },
        { no: "03", title: "Delivery", desc: "The load reaches the shop's door along the digital route, right on time." },
      ],
      intro_title_1: "We move freight.",
      intro_title_2: "We own the outcome.",
      intro_body: "With every service under one roof and one accountable team, your supply chain moves the way your business demands: predictably, transparently, and without excuses. No finger-pointing between vendors, no delays lost in handoffs — one team, from origin to destination.",
      intro_link: "About us",
      stats_kicker: "From countless journeys, clarity emerges",
      speed_label: "average delivery performance",
      services_title_1: "Everything your load needs.",
      services_title_2: "On one platform.",
      services_sub: "From load matching to live tracking, secure payments to a vast driver network — the whole process, end to end, in one place.",
      why_kicker: "Why us",
      why_title: "Logistics that works as hard as you do.",
      why: [
        { t: "One Point of Contact", d: "No chasing multiple vendors. One team manages your load from origin to destination." },
        { t: "End-to-End Visibility", d: "Track your load in real time and get proactive updates before issues become delays." },
        { t: "Compliance You Trust", d: "Verified drivers and insured shipments keep every transaction secure." },
        { t: "Transparent Pricing", d: "No hidden fees. Clear, competitive pricing with fast support at every step." },
        { t: "Fast Resolution", d: "When something unexpected happens, we don't point fingers — we solve it." },
      ],
      reliability_title_1: "Reliability at",
      reliability_title_2: "every milestone.",
      features: [
        { t: "Real-Time Tracking", d: "Know exactly where your load is at every milestone. Live visibility, zero guesswork." },
        { t: "Vast Driver Network", d: "Tens of thousands of verified drivers across 81 provinces, on every route you rely on." },
        { t: "24/7 Support", d: "Real people, always available. Routine or urgent — we pick up and own the outcome." },
      ],
      testimonials_kicker: "References",
      testimonials_title: "Trusted by businesses across Turkey",
      testimonials: [
        { q: "Our operation wouldn't run without Aportta. They treat our loads like their own — fast and transparent.", n: "Mehmet Yıldız", r: "Operations Director, Anadolu Textile" },
        { q: "We found the personal service we never got at bigger firms. Our dedicated account manager knows our business.", n: "Ayşe Demir", r: "Supply Chain Manager, Ege Food" },
        { q: "Prices are clear, tracking is live, support is always on. They find the fastest route every time.", n: "Can Kaya", r: "GM, Marmara Logistics" },
      ],
      partners_kicker: "Our partners",
      partners: ["ANADOLU NAKLİYAT", "EGE LOJİSTİK", "MARMARA KARGO", "TOROS TAŞIMA", "KARADENİZ FİLO", "AKDENİZ EXPRESS", "İÇ ANADOLU YÜK", "TRAKYA TRANS"],
      faq_title: "FAQ",
      faq_sub: "Straightforward answers, so you can move forward with confidence.",
      faqs: [
        { q: "What does Aportta do?", a: "Aportta is a digital freight & transport platform that matches shippers with drivers in seconds, with live tracking and secure payments." },
        { q: "How do I post a load?", a: "Create your listing on app.aportta.com, enter route and cargo details, set your price. The algorithm matches you with the best driver." },
        { q: "How does payment work?", a: "Your payment is held in escrow until delivery is confirmed, then released to the driver." },
        { q: "Which provinces are covered?", a: "We operate across 81 provinces with tens of thousands of active drivers for city and intercity transport." },
        { q: "How do I track my load?", a: "Follow the location live on the map, 24/7, from pickup to delivery." },
        { q: "How do I get support?", a: "Reach our 24/7 support team by phone or email." },
      ],
      final_title: "Ready to move smarter?",
      final_sub: "No call centres, no runaround. Just experienced people helping you grow and a platform that matches in seconds.",
      stats: [
        { value: "50K+", label: "Active Drivers" },
        { value: "99%", label: "Safe Delivery" },
        { value: "81", label: "Provinces" },
        { value: "24/7", label: "Live Support" },
      ],
      marquee: "SECURE · FAST MATCHING · LIVE TRACKING · SAFE PAYMENTS · 81 PROVINCES",
      how_title: "Your load, on the road in three steps",
      how_sub: "No complex searches, no phone chaos, no uncertainty. Just a clear, fast and secure flow.",
      steps: [
        { no: "01", title: "Define your load", desc: "Enter origin, destination, time and cargo. Set your own price." },
        { no: "02", title: "Match your driver", desc: "Our algorithm matches the best, top-rated drivers in seconds." },
        { no: "03", title: "Track it live", desc: "Follow every step on the map from pickup to delivery." },
      ],
      cta_band_title: "Get your load moving today.",
      cta_band_sub: "Create your listing in seconds on the Aportta panel.",
    },
    about: {
      eyebrow: "ABOUT US",
      title: "Rewriting logistics.",
      intro: "Aportta was founded to transform Turkey's freight and transport industry into a transparent, fast and reliable digital experience.",
      chapters: [
        { no: "01", title: "Our Vision", text: "A Turkey where every load meets the right driver fast and no truck returns empty. Efficiency that wins for both the planet and the economy." },
        { no: "02", title: "Our Technology", text: "A real-time matching algorithm, live GPS tracking and a secure payment layer bring the whole journey into a single panel." },
        { no: "03", title: "Our Trust", text: "Verified drivers, insured shipments and a rating system make trust the standard. Your money stays safe until delivery is confirmed." },
        { no: "04", title: "Our Network", text: "Tens of thousands of active drivers and thousands of businesses across 81 provinces. The more we grow, the faster and cheaper for everyone." },
      ],
    },
    services: {
      eyebrow: "OUR SERVICES",
      title: "End-to-end digital logistics.",
      intro: "Everything you need, from posting a load to delivery, on one platform.",
      items: [
        { title: "Load Matching", desc: "A smart algorithm matches your load with the ideal driver in seconds." },
        { title: "Live Tracking", desc: "Follow your load's location in real time on the map, 24/7." },
        { title: "Secure Payment", desc: "Your payment is held in escrow until delivery is confirmed." },
        { title: "Driver Network", desc: "Instantly access a wide network of verified, rated and insured drivers." },
        { title: "Enterprise Solutions", desc: "Bulk load management, invoicing and reporting for businesses." },
        { title: "24/7 Support", desc: "Our expert support team is always there to solve issues instantly." },
      ],
    },
    contact: {
      eyebrow: "CONTACT",
      title: "Let's talk.",
      intro: "Reach out for questions, partnerships and support.",
      email_label: "Email",
      phone_label: "Phone",
      address_label: "Address",
      address: "Maslak, Sarıyer, İstanbul, Türkiye",
      hours_label: "Working Hours",
      hours: "Weekdays 09:00 – 18:00 · Support 24/7",
    },
    footer: {
      tagline: "Turkey's digital freight & transport platform.",
      rights: "All rights reserved.",
      product: "Product",
      company: "Company",
    },
  },
};

export const CONTACT = {
  email: "merhaba@aportta.com",
  phone: "+90 850 000 00 00",
};

export const APP_URL = "https://app.aportta.com";
export const LOGO_URL = "https://app.aportta.com/brand/brand-logo.png";
